export default __webpack_public_path__ + "media/pdf.11b163c3.svg";